import type { MouseEvent } from 'react';

import BpkButton, { BUTTON_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-button';

import AccountIcon from './AccountIcon';

import STYLES from './LoginButton.module.scss';

type Props = {
  profilePictureUrl: string | null;
  onProfilePictureError: () => void;
  onLoginClick: (e: MouseEvent<HTMLButtonElement>) => void;
  accountText: string;
};

const ProfilePicture = ({
  accountText,
  onLoginClick,
  onProfilePictureError,
  profilePictureUrl,
}: Props) => (
  <BpkButton
    className={STYLES.ProfilePicture}
    type={BUTTON_TYPES.linkOnDark}
    aria-label={accountText}
    onClick={onLoginClick}
    iconOnly
  >
    {profilePictureUrl ? (
      <img
        className={STYLES.ProfilePicture__image}
        onError={onProfilePictureError}
        alt={accountText}
        src={profilePictureUrl}
      />
    ) : (
      <span className={STYLES.ProfilePicture__icon}>
        <AccountIcon />
      </span>
    )}
  </BpkButton>
);

export default ProfilePicture;
